export default __webpack_public_path__ + "static/media/icon_photo.ea22ec93.svg";